'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.types = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

exports.playVideo = playVideo;
exports.fetchVideo = fetchVideo;

var _reduxApiMiddleware = require('@aftonbladet/redux-api-middleware');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PACKAGE_PREFIX = '@spp/video-asset';

var types = exports.types = {
    PLAY_VIDEO: PACKAGE_PREFIX + '_PLAY_VIDEO',
    REQUEST_VIDEO: PACKAGE_PREFIX + '_REQUEST_VIDEO',
    RECEIVE_VIDEO: PACKAGE_PREFIX + '_RECEIVE_VIDEO',
    RECEIVE_VIDEO_ERROR: PACKAGE_PREFIX + '_RECEIVE_VIDEO_ERROR'
};

function playVideo(videoNodeID, startMode) {
    return {
        type: types.PLAY_VIDEO,
        payload: videoNodeID,
        meta: { startMode: startMode }
    };
}

function fetchVideo(id, _ref) {
    var reduxPath = _ref.reduxPath,
        apiUrl = _ref.apiUrl;

    return (0, _defineProperty3.default)({}, _reduxApiMiddleware.CALL_API, {
        bailout: function bailout(state) {
            return Boolean((0, _get3.default)(state, reduxPath, state).videos[id]);
        },
        endpoint: apiUrl + '/v1/videos/' + id,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        types: [{
            type: types.REQUEST_VIDEO,
            meta: { id: id }
        }, {
            type: types.RECEIVE_VIDEO,
            meta: { id: id }
        }, {
            type: types.RECEIVE_VIDEO_ERROR,
            meta: { id: id }
        }]
    });
}
//# sourceMappingURL=redux-actions.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/video-asset/lib/cjs/redux-actions.js
 ** module id = 306
 ** module chunks = 1
 **/